const BASE = `${process.env.REACT_APP_MyAMP_Url}/api/ams/mycarrier-finder`;

function authHeaders(): Record<string, string> {
  const token = localStorage.getItem('authToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export interface CarrierFinderDocument {
  id: string;
  fileName: string;
  createdDate?: string;
  status?: string;
}

export async function checkStatus(): Promise<boolean> {
  try {
    const res = await fetch(`${BASE}/checkstatus`, { headers: authHeaders() });
    if (!res.ok) return false;
    const data = await res.json();
    return data.isConfigured === true || data.status === true;
  } catch {
    return false;
  }
}

export async function getFiles(): Promise<CarrierFinderDocument[]> {
  try {
    const res = await fetch(`${BASE}/getallfiles`, { headers: authHeaders() });
    if (!res.ok) return [];
    const data = await res.json();
    return data.response || data || [];
  } catch {
    return [];
  }
}

export async function uploadFiles(files: File[], userPrompt?: string): Promise<void> {
  const formData = new FormData();
  files.forEach((f) => formData.append('files', f));
  formData.append('uploadedFrom', 'InsuranceAgencyAI');
  if (userPrompt) formData.append('userPrompt', userPrompt);
  const res = await fetch(`${BASE}/documents-upload`, {
    method: 'POST',
    headers: authHeaders(),
    body: formData,
  });
  if (!res.ok) throw new Error('Failed to upload files');
}

export async function deleteFile(id: string): Promise<void> {
  const res = await fetch(`${BASE}/delete/${id}`, {
    method: 'DELETE',
    headers: authHeaders(),
  });
  if (!res.ok) throw new Error('Failed to delete file');
}
